<template>
  <div style="height: 100%; position: relative;">
    <div id="BalanceBarCashYears" class="" style="position: absolute; top: 0; left: 0; right: 0; bottom: 40px;"></div>
    <div class="center" style="position: absolute; bottom: 0; left: 0; right: 0;">
      <span class="dot primary"></span> {{ 'Kassa & Bank' | T }}
    </div>
  </div>
</template>

<script>
/* tslint:disable */
import Highcharts from 'highcharts'
import Vue from 'vue';
import {colors} from '@/config';

export default {
  name: "BalanceBarCashYears",
  components: {},
  props: {
    balance: Object
  },

  mounted() {
    this.chart = new Highcharts.chart({

      chart: {
        type: 'column',
        renderTo: 'BalanceBarCashYears',
        backgroundColor: 'transparent',
      },

      credits: {
        enabled: false,
      },

      title: {
        text: ''
      },

      legend: {
        enabled: false
      },

      colors: [colors.Primary, colors.Tertiary],

      xAxis: {
        categories: this.balance.sheets.map( s => s.DATE_TO.substr(0, 4) ).reverse(),
        labels: {
          style: { fontSize: '1rem', color: colors.Black, }
        }
      },

      yAxis: [{
        opposite: true,
        allowDecimals: false,
        title: {
          text: ''
        },
        labels: {
          formatter() { return Vue.options.filters.KR(this.value); },
          style: { fontSize: '1rem', color: colors.DarkGrey, }
        },
        tickPixelInterval: 150,
        gridLineColor: colors.LightGrey,
        plotLines: [{
          color: colors.Black,
          width: 2,
          value: 0,
          zIndex: 2,
      }],

      }],

      tooltip: {
        formatter: function () {
          let p = this;
          return this.series.tooltipOptions.tooltip.call(p);
        },
        style: { fontSize: '1.25rem', color: colors.Black,},
        backgroundColor: colors.Light,
      },

      plotOptions: {
        column: {
          stacking: 'normal',
          borderColor: colors.DarkGrey,
        }
      },

      series: [{
        name: Vue.prototype.$t('Kassa & Bank'),
        data: this.balance.sheets.map( (s,i) => i === 0 ? {y: s.J, color: colors.Secondary} : s.J ).reverse(),
        tooltip: {
          tooltip: function() {
            return '<b>' + this.series.name + '<br>' + Vue.options.filters.TKR(this.y);
          }
        },
        stack: 'intakt'
      }],
    });
  },

}
</script>

<style scoped lang="scss">
.dot {
  height: 20px;
  width: 20px;
  border-radius: 50%;
  display: inline-block;
}

.primary {
  background: linear-gradient( -45deg, get('colors.Secondary'), get('colors.Secondary') 50%, get('colors.Primary') 50%);
  border-radius: 50%;
}

.result {
  background: linear-gradient( -45deg, #e70407, #e70407 50%, #a4e408 50%);
  border-radius: 50%;
}

.center {
  font-size: 1.2rem;
}
</style>
